import instance from "../apis/axiosConfig";

// GET ALL
export const getMainTitleSettings = () =>
  instance.get("mainTitleSettings/getAll");

// UPDATE
export const updateMainTitleSettings = (id, data) =>
  instance.post(`mainTitleSettings/update/${id}`, data);